import { useCallback, useEffect, useRef, useState } from "react";

export function useSetTimeout()
{
    const entries = useRef<Set<number>>(new Set());

    useEffect(() => () => {
        entries.current.forEach(id => clearTimeout(id));
        entries.current.clear();
    }, []);

    const execute = useCallback((id:number, action:() => any) => {
        entries.current.delete(id);
        action();
    }, []);

    const add = useCallback((action:() => any, timeout:number) => {
        const id = window.setTimeout(() => execute(id, action), timeout);
        entries.current.add(id);
        return id;
    }, []);

    const clear = useCallback((id:number) => {
        if(entries.current.has(id)) { clearTimeout(id); }
        entries.current.delete(id);
    }, []);

    return { setTimeout:add, clearTimeout:clear };
}

export function useFocusTimer(): [boolean, () => void, () => void] {
    const [hasFocus, setHasFocus] = useState(false);
    const blurTimer = useRef<number>();

    const handleFocus = (state: boolean) => {
        if (blurTimer.current) { clearTimeout(blurTimer.current); }
        blurTimer.current = undefined;

        if (state) { setHasFocus(true); }
        else {
            blurTimer.current = window.setTimeout(() => setHasFocus(false), 1000);
        }
    }

    return [hasFocus, () => handleFocus(true), () => handleFocus(false)];
}